<template>
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width="24" 
        height="24" 
        viewBox="0 0 24 24"
        fill="none" 
        :class="svgClass"
        :stroke="strokeColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round" 
        class="lucide lucide-map-pin-plus-icon lucide-map-pin-plus"
    >
        <path d="M12.75 7.09a3 3 0 0 1 2.16 2.16"/><path d="M17.072 17.072c-1.634 2.17-3.527 3.912-4.471 4.727a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 1.432-4.568"/><path d="m2 2 20 20"/><path d="M8.475 2.818A8 8 0 0 1 20 10c0 1.183-.31 2.377-.81 3.533"/><path d="M9.13 9.13a3 3 0 0 0 3.74 3.74"/>
    </svg>
</template>

<script setup>
import { defineProps, computed } from 'vue';

const props = defineProps(['iconClass', 'stroke'])

const svgClass = computed(()=>{
    return props.iconClass ? props.iconClass : 'h-3 w-3'
})

const strokeColor = computed(() => {
    return props.stroke ? props.stroke : 'black'
})

</script>